// extracted by mini-css-extract-plugin
module.exports = {"articlesContainer":"b7_cH","articleItem":"b7_cJ","imageArticle":"b7_cL","info":"b7_P"};